import { all, call, put, takeLatest } from 'redux-saga/effects';
import { fetchFeatureFlags } from 'services/featureFlagService';
import { featureFlagActions } from 'store/featureFlagSlice/featureFlagSlice';
import { notificationHandler } from 'utils/utils';

function* getFeatureFlag() {
    try {
        const response = yield call(fetchFeatureFlags);
        const featureFlags = response?.data || {};

        for (const [key, value] of Object.entries(featureFlags)) {
            yield put(featureFlagActions.setFeatureFlag({ key, value }));
        }
    } catch (err) {
        yield call(notificationHandler, { title: 'Error fetching enabled feature flag' });
    }
}

function* onGetFeatureFlagData() {
    yield takeLatest(featureFlagActions.getFeatureFlagData.type, getFeatureFlag);
}

export function* featureFlagSaga() {
    yield all([call(onGetFeatureFlagData)]);
}
